<template>
  <div>
    <training-toolbar/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="$t('message.applyActivitiesMgmt')"
        :iconName="'file-person'"
      />
      <b-card-body>
        <div >
          <b-row>
            <b-form-group
                id="apply-status"
                :label="$t('applyActivity.status')"
                label-for="input-apply-status"
                label-align="left"
                label-cols-sm="6"
                content-cols-sm
                class="col-lg-4"
            >
              <b-form-select v-model="status" :options="statuses">
              </b-form-select>
            </b-form-group>

            <b-button class="ml-auto mr-3 esep-blue-bg" variant="primary" @click="getApplyActivities">
              {{ $t('trainings.search') }}
            </b-button>
          </b-row>
        </div>

        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>
        <b-table
          :busy="isBusy"
          :items="applyActivities"
          :fields="fields"
          responsive
          show-empty
          thead-class="esep-blue-bg text-light"
        > 
          <template #table-busy> 
            <b-spinner ></b-spinner>
          </template>

          <template v-slot:cell(memberValidator)="row">

            <v-select
                :options="trainers"
                v-model="row.item.memberValidator"
                class="bg-white rounded"
                label="fullName"
            >
            </v-select>
          </template>

          <template v-slot:cell(action)="row">
            <b-button
                size="sm"
                @click="assignValidator(row)"
                variant="transparent"
                v-b-tooltip.hover
                :title="$t('applyActivity.assignValidator')"
            >
              <b-icon icon="folder-symlink"></b-icon>
            </b-button>
            <b-button
                size="sm"
                @click="goToEvaluation(row.item)"
                variant="transparent"
                v-b-tooltip.hover
                :title="$t('applyActivity.goTo')"
            >
              <b-icon icon="box-arrow-right" ></b-icon>
            </b-button>
          </template>

          <template v-slot:empty="">
            <h6>{{ $t("applyActivity.emptyApplyActivitiesTable") }}</h6>
          </template>
        </b-table>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';


export default {
  components: {
    TrainingToolbar,
    CardHeader,
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;
        this.getApplyActivities();
        this.getActiveLeaders();
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      fields: [
        { key: "dateCreated", label: "Ημ/νία Δημιουργίας", sortable: true, thClass: 'text-left', tdClass: 'text-left', formatter: 'showDate' },
        { key: "module.title", label: "Εκπ. Ενότητα", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "member", label: "Ονοματεπώνυμο", sortable: true, sortByFormatted: true, filterByFormatted: true, formatter: "formatFullName", thClass: 'text-left', tdClass: 'text-left'},
        { key: "member.orgUnit.name", label: "Κλιμάκιο", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "validationUnit.name", label: "Υπεύθυνο Κλιμάκιο", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "memberValidator", label: "Επιβλέπων", sortable: false, thClass: 'min-width-300'},
        { key: "dateAssigned", label: "Ημ/νία Ανάθεσης", sortable: true, thClass: 'text-left', tdClass: 'text-left', formatter: 'showDate' },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      trainers: [],
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      applyActivities: [],
      status: 'ASSIGN_PENDING',
      statuses: [
        { value: 'ASSIGN_PENDING', text: this.$t('trainingApplyActivityEnums.ASSIGN_PENDING')  },
        { value: 'IN_PROGRESS', text: this.$t('trainingApplyActivityEnums.IN_PROGRESS')  },
        // { value: 'COMPLETED', text: this.$t('trainingApplyActivityEnums.COMPLETED')  },
        // { value: 'FAILED', text: this.$t('trainingApplyActivityEnums.FAILED')  },
      ],
      isBusy: false
    }
  }, 
  methods: {
    formatFullName(member) {
      return member.surName +" " + member.firstName;
    },
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    getApplyActivities() {
      this.isBusy = true;
      trainingService.getApplyActivities(null, null, this.status).then(
        (response) => {
          this.isBusy = false;
          this.applyActivities = response.data.filter(a => a.applyMethod !== 'IN_TRAINING').map( activity => {
            if (activity.memberValidator) {
              activity.memberValidator.fullName = activity.memberValidator.surName + ' ' + activity.memberValidator.firstName;
            }
            return activity;
          });
        },
        (error) => {
          this.isBusy = false;
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    getActiveLeaders() {
      trainingService.getLeaderLicensesByCriteria(null, ['ACTIVE'], null).then(
          (response) => {
            this.trainers = response.data.map( leader => {
              leader.fullName = leader.member.surName + ' ' + leader.member.firstName ;
              return leader;
            });
          }, (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      );
    },
    assignValidator(row) {
      this.isBusy = true;
      trainingService.assignApplyActivity(row.item.id, row.item.memberValidator.member).then(
          (response) => {
            row.item = response.data;
            this.makeToast("Επιτυχής ανάθεση παραστάτη")
            this.getApplyActivities();
            this.isBusy = false;
          }, (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
            this.isBusy = false;
          }
      );
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        variant: 'success',
        title: 'Επιτυχία',
        solid: true
      })
    },
    goToEvaluation(activity) {
      window.open(`/app/training/web/apply-activities/${activity.id}`, '_blank');
    },
    showDate(datetime) {
      return datetime? new Date(datetime).toLocaleDateString(): '';
    },
  }
}
</script>

<style>
  .min-width-300 {
    min-width: 300px;
  }
</style>